let state = {
    mobileEmpty: false,     // 手机号码为空
    checkCodeEmpty: false,  // 验证码为空

    checkCodeError: false,  // 验证码错误
    mobileError: false, // 手机号码已被注册
}

const mutations = {
    switchEmpty(state, data) {
        let name = data.name + 'Empty'
        state[name] = data.status
    },
    switchError(state, data) {
        let name = data.name + 'Error'
        state[name] = data.status
    }
}

export default {
    state,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/input.js